// Server-side — reads env directly at runtime
export const API_ROOT = process.env.API_URL;
export const WEB_ROOT = process.env.WEB_URL;
export const SECURE_COOKIES = !process.env.WEB_URL?.includes("localhost");
export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? "INVALID";
export const SHOW_CAPTCHA = process.env.URALITY_SERVER !== "local";
